var React = require('react');

function Preview (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.975 5C9.675 5 10.975 6.3 10.975 8C10.975 9.7 9.675 11 7.975 11C6.275 11 4.975 9.7 4.975 8C4.975 6.3 6.275 5 7.975 5M8 14C11.6113 14 14.4201 10.9 15.6238 9.1C16.1254 8.4 16.1254 7.5 15.6238 6.8C14.4201 5.1 11.6113 2 8 2C4.38871 2 1.57994 5.1 0.376176 6.9C-0.125392 7.6 -0.125392 8.5 0.376176 9.1C1.57994 10.9 4.38871 14 8 14","fill":"#181818"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"d":"M0 0H16V16H0V0Z","fill":"white"})))]);
}

Preview.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Preview;

Preview.default = Preview;
